import React, { useState } from 'react';
import Checkbox from '@uber/base-icons/checkbox';
import CheckboxChecked from '@uber/base-icons/checkbox-checked';
import ChevronDown from '@uber/base-icons/chevron-down';
import ChevronUp from '@uber/base-icons/chevron-up';
import PencilLine from '@uber/base-icons/pencil-line';
import { useStyletron } from 'baseui';
import { Button, KIND, SHAPE, SIZE } from 'baseui/button';
import { SIZE as DIVIDER_SIZE, StyledDivider } from 'baseui/divider';
import { Tag } from 'baseui/tag';
import { LabelXSmall, ParagraphSmall } from 'baseui/typography';
import { ActionButtonContainer, ExpandedItemContainer, ExpandedItemHeader, ListItemContainer, ListItemContent, StyledCheckBox } from './styled-components';
type Props = {
  label: string;
  description: string;
  isLast: boolean;
  onEditFeedback: () => void;
  isSelectMode?: boolean;
  isSelected?: boolean;
  onSelect?: () => void;
};
export const FeedbackListItem = ({
  label,
  description,
  isLast,
  onEditFeedback,
  isSelectMode = false,
  isSelected = false,
  onSelect
}: Props) => {
  const [_, theme] = useStyletron();
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  return <ListItemContainer $isLast={isLast}>
      {isSelectMode && <StyledCheckBox onClick={onSelect} data-testid="select-checkbox">
          {isSelected ? <CheckboxChecked /> : <Checkbox />}
        </StyledCheckBox>}
      {isExpanded ? <ExpandedItemContainer>
          <ExpandedItemHeader>
            <Tag closeable={false} overrides={{
          Root: {
            style: {
              margin: 0
            }
          }
        }}>
              <LabelXSmall color={theme.colors.contentSecondary}>{label}</LabelXSmall>
            </Tag>
            <ActionButtonContainer>
              <Button kind={KIND.tertiary} size={SIZE.mini} shape={SHAPE.square} onClick={onEditFeedback} disabled={isSelectMode} data-testid="edit-button">
                <PencilLine />
              </Button>
              <Button kind={KIND.tertiary} size={SIZE.small} shape={SHAPE.circle} onClick={() => setIsExpanded(false)} data-testid="collapse-button">
                <ChevronUp height={theme.sizing.scale600} width={theme.sizing.scale600} />
              </Button>
            </ActionButtonContainer>
          </ExpandedItemHeader>
          <StyledDivider $size={DIVIDER_SIZE.cell} $style={{
        width: '100%',
        margin: 0
      }} />
          <ParagraphSmall color={theme.colors.contentSecondary} margin={0}>
            {description}
          </ParagraphSmall>
        </ExpandedItemContainer> : <>
          <ListItemContent>
            <Tag closeable={false} overrides={{
          Root: {
            style: {
              margin: 0
            }
          }
        }}>
              <LabelXSmall color={theme.colors.contentSecondary}>{label}</LabelXSmall>
            </Tag>
            <ParagraphSmall color={theme.colors.contentSecondary} $style={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        }}>{`\u2022 ${description}`}</ParagraphSmall>
          </ListItemContent>
          <Button kind={KIND.tertiary} size={SIZE.small} shape={SHAPE.circle} onClick={() => setIsExpanded(true)} data-testid="expand-button">
            <ChevronDown height={theme.sizing.scale600} width={theme.sizing.scale600} />
          </Button>
        </>}
    </ListItemContainer>;
};